import LazyLoad from "vanilla-lazyload";
import 'core-js/es/array';

export default class Lazyload {

    constructor() {

        // lazy loading
        const lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy"
            // ... more custom settings?
        });

    }

}